module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [(_vm.editsms) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.sms.edit')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.sms.new')))]), _vm._v("\n        " + _vm._s(_vm.$t('vue2.sms.standard_sms')))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.sms.subject')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "titleInput",
    class: {
      'input--error': _vm.errors.title
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.sms.ex_you_are_sub')
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        return _vm.resetValidation('title')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.title) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.errors.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group marg-10-top"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.sms.message')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    ref: "smsbodyinput",
    class: {
      'input--error': _vm.errors.body
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "keyup": function($event) {
        return _vm.resetValidation('body')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.body) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.errors.body))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "bttn--small marg-5-top",
    on: {
      "click": _vm.insertToday
    }
  }, [_vm._v(_vm._s(_vm.today))]), _vm._v(" "), _c('span', {
    staticClass: "d-desc link",
    on: {
      "click": _vm.insertToday
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.sms.insert_today_to')) + " \"" + _vm._s(_vm.today) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-10-right",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.editsms) ? _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.updateTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')) + "\n      ")]) : _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8636a778!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/MessageTemplate.vue
// module id = 1760
// module chunks = 1